// src/pages/products/EditProductPage/components/AttributesTab.jsx
import React, { useState, useEffect } from 'react';
import { useLocalization } from '../../../../contexts/LocalizationContext';
import AttributeSelector from '../../../../components/product/AttributeSelector/AttributeSelector';
import styles from '../styles/AttributesTab.module.css';

const AttributesTab = ({
  formData,
  errors,
  onAttributesChange,
  onAttributeValuesChange,
  isEdit = false
}) => {
  const { t } = useLocalization();

  const getAttributesDescription = () => {
    if (isEdit) {
      return formData.productType === 'variable' 
        ? t('products.attributesVariableEditDesc') || 'Select attributes to use for product variations. Changes will affect existing variations.'
        : t('products.attributesEditDesc') || 'Select attributes that describe this product.';
    }
    return formData.productType === 'variable' 
      ? t('products.attributesVariableDesc') || 'Select attributes to create product variations (e.g., Size, Color).'
      : t('products.attributesDesc') || 'Select attributes that describe this product.';
  };

  return (
    <div className={styles.attributesContainer}>
      {/* Attributes Section */}
      <div className={styles.formCard}>
        <div className={styles.cardHeader}>
          <h2>{t('products.attributes') || 'Attributes'}</h2>
          <p>{getAttributesDescription()}</p>
        </div>
        <div className={styles.cardContent}>
          <div className={styles.formGroup}>
            <label htmlFor="attributes">
              {t('products.selectAttributes') || 'Select Attributes'}
              {formData.productType === 'variable' && (
                <span className={styles.required}>*</span>
              )}
            </label>
            <AttributeSelector
              selectedAttributeIds={formData.attributeIds || []}
              selectedAttributeValueIds={formData.attributeValueIds || []}
              onAttributesChange={onAttributesChange}
              onAttributeValuesChange={onAttributeValuesChange}
              productType={formData.productType}
              error={errors.attributes}
            />
            {errors.attributes && (
              <div className={styles.errorMessage}>
                {errors.attributes}
              </div>
            )}
          </div>

          {/* Variable product warning */}
          {formData.productType === 'variable' && (!formData.attributeIds || formData.attributeIds.length === 0) && (
            <div className={styles.warningMessage}>
              <i className={styles.warningIcon}>⚠️</i>
              {t('products.variableProductAttributesRequired') || 'Variable products require at least one attribute for variations.'}
            </div>
          )}

          {/* Show helpful info for variable products */}
          {formData.productType === 'variable' && formData.attributeIds && formData.attributeIds.length > 0 && (
            <div className={styles.infoMessage}>
              <i className={styles.infoIcon}>ℹ️</i>
              <div>
                <p>{t('products.variationAttributesInfo') || 'Attributes marked as "Used for variations" will generate product variations.'}</p>
                <p>{t('products.variationAttributesInfo2') || 'Make sure to select attribute values to create the variations you need.'}</p>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Edit Mode Actions */}
      {isEdit && (
        <div className={styles.editActions}>
          <div className={styles.changesSummary}>
            <p>{t('products.changesWillUpdateVariations') || 'Changes to attributes may affect existing product variations.'}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default AttributesTab;